<template>
  <woot-modal
    v-if="isAdmin"
    :show.sync="showPopup"
    :show-button-close="false"
    :on-close="hidePopup"
  >
    <div class="column content-box">
      <woot-modal-header
        class="text-center"
        :header-title="$t('OBSERVER_MODE.TITLE')"
      />

      <form @submit.prevent="toggleMode" class="row">
        <div class="medium-12 columns observer-content">
          <p class="observer-description">
            {{ $t('OBSERVER_MODE.DESCRIPTION') }}
          </p>
          <ul class="observer-list">
            <li>{{ $t('OBSERVER_MODE.LI_1') }}</li>
            <li>{{ $t('OBSERVER_MODE.LI_2') }}</li>
            <li>{{ $t('OBSERVER_MODE.LI_3') }}</li>
          </ul>
        </div>

        <div class="modal-footer">
          <woot-button class="button-cancel" @click.prevent="hidePopup">
            {{ $t('OBSERVER_MODE.BUTTON_CANCEL') }}
          </woot-button>

          <woot-button class="button-active" type="submit">
            {{
              isObserverMode
                ? $t('OBSERVER_MODE.TOOLTIP_DISABLE')
                : $t('OBSERVER_MODE.BUTTON_ACTIVE')
            }}
          </woot-button>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import adminMixin from '../../../mixins/isAdmin';
import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [adminMixin],
  data() {
    return {
      showPopup: false,
    };
  },
  computed: {
    ...mapGetters({
      isObserverMode: 'observerMode/isObserverMode',
    }),
  },
  methods: {
    ...mapActions('observerMode', ['setMode']),
    openPopup() {
      if (this.isAdmin) {
        this.showPopup = true;
      }
    },
    hidePopup() {
      this.showPopup = false;
    },
    toggleMode() {
      if (this.isAdmin) {
        this.setMode(!this.isObserverMode);
        this.hidePopup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.observer-description {
  font-size: var(--font-size-small);
  line-height: 1.6;
}

.observer-list {
  font-size: var(--font-size-small);
  line-height: 1.6;
  margin-bottom: var(--space-smaller);
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.button-cancel,
.button-active {
  min-width: 120px;
  background-color: var(--c-500);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.button-cancel:hover,
.button-active:hover {
  background-color: var(--w-800);
}
</style>